import { namedUuid } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import {
	StyledRadioAlert,
	StyledRadioContainer,
	StyledRadioGroup,
	StyledRadioLegend,
} from './styled-radio-group';

const { forwardRef, useMemo } = React;

const propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	groupName: PropTypes.string.isRequired,
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	errorMessage: PropTypes.string,
	legend: PropTypes.string,
	stacked: PropTypes.bool,
};

const defaultProps = {
	className: '',
	dataTestId: '',
	errorMessage: '',
	legend: '',
	stacked: true,
};

const RadioGroup = forwardRef(
	(
		{ children, className, dataTestId, errorMessage, groupName, legend, stacked, ...others },
		ref,
	) => {
		// Unique IDs
		const alertId = useMemo(() => namedUuid('fuse-radio-group-alert'), []);

		return (
			<StyledRadioGroup
				className={className}
				data-testid={dataTestId || 'fuse-radio-group'}
				ref={ref}
				{...others}
			>
				{!!legend && (
					<StyledRadioLegend size={{ xxs: 'm1', m: '1' }} tag="legend" type="heading">
						{legend}
					</StyledRadioLegend>
				)}
				{!!errorMessage && (
					<StyledRadioAlert
						id={alertId}
						message={errorMessage}
						role="alert"
						showIcon
						size="small"
						variant="error"
					/>
				)}
				<StyledRadioContainer stacked={stacked}>
					{React.Children.map(children, (el) =>
						React.cloneElement(el, {
							'aria-describedby': errorMessage ? alertId : '',
							'aria-invalid': errorMessage ? true : undefined,
							name: groupName,
						}),
					)}
				</StyledRadioContainer>
			</StyledRadioGroup>
		);
	},
);

RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;

export default RadioGroup;
export { RadioGroup };
